import React, { FC } from "react";
import { Button } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";

const Modal = () => {
  const { title, message, icon, action } = useStateGetter().modalOBJ;

  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col  justify-center items-center rounded-[8px] bg-white w-[80vw]    md:w-[40vw] p-4 ">
          {icon}
          {/* <p className="font-semibold p-3 ">{title}</p> */}
         {title!="" && <p className="font-light">{title}</p>
}
          {action && action}
        </div>
      </div>
    </>
  );
};

export default Modal;
